import suiteService from 'qreventos-suite/services';

class SuiteConfig {
    evento:number = 546;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
    clientId: string = '1036a014-ec7a-45f8-9085-6ca43c7c5b11-546';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  
    }
}

export default new SuiteConfig();
